import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import HomePage from "./components/HomePage.vue";
import AboutMe from "./components/AboutMe.vue";
import Test from "./components/Test.vue";

import { PROJECTS } from "@/data";

const routes: RouteRecordRaw[] = [
	{
		path: "/",
		component: HomePage,
	},
	{
		path: "/about",
		component: AboutMe,
	},
	{
		path: "/test",
		component: Test,
	},
];

PROJECTS.forEach((project) =>
{
	routes.push({
		path: `/${project.link}`,
		component: HomePage,
		props: {
			startingProject: project.link
		},
	});
});

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;